import type { HTMLAttributes } from 'react';

export enum MRateTitleSize {
  S = 'S',
}

export type MRateTitleProps = HTMLAttributes<HTMLDivElement> & {
  size?: MRateTitleSize;
  text: string;
};
